<template lang="html">
	<div class="custom-select" :class="{solo: solo}">
		<div class="selected" @click.stop="display()">
			{{ this.select || '&nbsp;' }}
			<span class="icon-arrow-full-down" :class="{deploy: show}"></span>
		</div>
		<div class="items" v-if="show">
			<div class="item" v-for="(item, key) in items" v-bind:key="key" @click.stop="setSelect(key)">
				<span v-if="object">{{ item.type }}</span><span v-else>{{ item }}</span>
			</div>
		</div>
	</div>
</template>

<script>
/*
 For now it support several things :
 v-model and default selected / change emit
 but for the well being of validation I started to
 make change into v-model value
*/
export default {
	name: 'custom-select',
	props: ['value', 'items', 'selected', 'solo', 'object'],
	data () {
		return {
			select: null,
			show: false
		}
	},
	mounted () {
		if (this.selected) {
			this.select = this.selected.type || this.selected
		} else {
			this.select = this.value || null
		}
	},
	methods: {
		setSelect (key) {
			this.select = this.items[key].type || this.items[key]
			this.show = false
			this.$emit('change', this.items[key])
			this.$emit('input', this.items[key])
		},
		display () {
			this.show = !this.show
			if (this.show) {
				window.addEventListener('click', this.checkClick)
			}
		},
		checkClick (e) {
			this.show = false
			window.removeEventListener('click', this.checkClick)
		}
	},
	watch: {
		selected: function (value) {
			this.select = value.type || value
		},
		value: function (value) {
			this.select = value
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// CustomSelect.vue?79533b34